(function () {
    'use strict';

    // @ngInject
    function InstantDepositModalControllerCtor($scope, $injector, $modalInstance, $timeout, $q, $translate, moment,
                                     AnalyticsService, StripeHelperService, PopupMessageService, WorkspaceFilesManager,
                                     CompaniesManager, UsersManager, source, workspaceFileId, invoiceId) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'InstantDepositModalController';
        this.$modalInstance = $modalInstance;
        this.CompaniesManager = CompaniesManager;
        this.WorkspaceFilesManager = WorkspaceFilesManager;
        this.PopupMessageService = PopupMessageService;
        this.StripeHelperService = StripeHelperService;
        this.$q = $q;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.moment = moment;
        this.AnalyticsService = AnalyticsService;
        this.UsersManager = UsersManager;
        this.source = source;
        this.workspaceFileId = workspaceFileId;
        this.company = CompaniesManager.getCurrCompany();
        this.user = this.UsersManager.getCurrUser();
        this.paymentAmount = 0;
        this.AnalyticsService.trackLoad(this, this.AnalyticsService.analytics_events.instant_deposit_modal, {source: this.source});
        this.ERROR_TYPES = {EXPIRED: 'expired', NOT_ALLOWED: 'notAllowed', MISSING_PAYMENT: 'missingPayment',
        IS_INSTANT: 'isInstant'};
        this.DEFAULT_ERROR = {
                event: this.AnalyticsService.analytics_events.confirm_instant_deposit_modal_error,
                icon: 'nx-modal__icon-error icon-hb-nx-triangle-exclamation-mark-42',
                title: 'ERRORS.SERVER_API._UNKNOWN_',
                description: 'ERRORS.SERVER_API._UNEXPECTED_',
                confirmButtonLabel: 'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.ERROR._MAIN_CTA_',
                mainCta: this.$modalInstance.close.bind(this)
        };
        this.STEPS = {
            ERROR: this.DEFAULT_ERROR
        };
        this.loading = false;
        this.loadingModalContent = true;
        this.payment = null;

        if(workspaceFileId && invoiceId) {
            this.getPayment(workspaceFileId, invoiceId);
        } else {
            this.handleError(this.ERROR_TYPES.MISSING_PAYMENT);
        }
    }

    Controllers.InstantDepositModalController = Class(Controllers.BaseController, {
        constructor: InstantDepositModalControllerCtor,

        init: function init() {
            if(this.payment.use_instant_payout) {
                this.handleError(this.ERROR_TYPES.IS_INSTANT);
            }
            else {
                this.WorkspaceFilesManager.allowChargedInstantPayout(this.workspaceFileId, this.payment._id)
                    .then(function onSuccess(resp) {
                        var isAllowed = resp && resp.data && resp.data.allow_charged_instant_payout;
                        if(isAllowed) {
                            if(this.isWithinTimeFrame(this.payment.payment_charge_date)) {
                                this.prepareNextSteps();
                                this.currentStep = this.STEPS.CONFIRM_INSTANT_DEPOSIT;
                                this.loadingModalContent = false;
                            }
                            else {
                                this.handleError(this.ERROR_TYPES.EXPIRED);
                            }
                        } else {
                            this.handleError(this.ERROR_TYPES.NOT_ALLOWED);
                        }
                    }.bind(this))
                    .catch(function onError(resp) {
                        this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.allow_instant_deposit_for_payment,
                           resp);
                        if(resp.data && resp.data.error_message) {
                            this.handleError(this.ERROR_TYPES.NOT_ALLOWED);
                        } else {
                            this.handleError();
                        }
                    }.bind(this));
                }
        },

        getPayment: function getPayment(workspaceFileId, invoiceId) {
            this.WorkspaceFilesManager.getPayment(workspaceFileId, invoiceId).then(
                function onSuccess(resp) {
                    this.payment = resp.data;
                    if(this.payment) {
                        this.init();
                    } else {
                        this.handleError(this.ERROR_TYPES.MISSING_PAYMENT);
                    }
                }.bind(this)).catch(
                function onError() {
                    this.handleError(this.ERROR_TYPES.MISSING_PAYMENT);
                }.bind(this)
            );
        },

        handleError: function handleError(type) {
            switch (type) {
                case 'expired':
                    this.STEPS.ERROR.title = 'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.ERROR._EXPIRED_TITLE_';
                    this.STEPS.ERROR.description = 'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.ERROR._EXPIRED_DESCRIPTION_';
                    break;
                case 'notAllowed':
                    this.STEPS.ERROR.title = 'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.ERROR._NOT_ALLOWED_TITLE_';
                    this.STEPS.ERROR.description = 'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.ERROR._NOT_ALLOWED_DESCRIPTION_';
                    break;
                case  'paymentMissing':
                    this.STEPS.ERROR.title = 'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.ERROR._MISSING_PAYMENT_TITLE_';
                    this.STEPS.ERROR.description = 'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.ERROR._MISSING_PAYMENT_DESCRIPTION_';
                    break;
                case 'isInstant':
                    this.STEPS.ERROR.title = 'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.ERROR._IS_INSTANT_TITLE_';
                    this.STEPS.ERROR.description = 'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.ERROR._IS_INSTANT_DESCRIPTION_';
                    break;
                default:
                    type = 'unknown';
            }
            this.AnalyticsService.trackLoad(this, this.AnalyticsService.analytics_events.instant_deposit_modal_error,
                {type: type});
            this.currentStep = this.STEPS.ERROR;
            this.loadingModalContent = false;
        },

        prepareNextSteps: function prepareNextSteps() {
            this.STEPS.CONFIRM_INSTANT_DEPOSIT = {
                event: this.AnalyticsService.analytics_events.confirm_instant_deposit,
                icon: 'icon-hb-nx-dollar-fast',
                title: 'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.CONFIRM_INSTANT_DEPOSIT._TITLE_',
                description: this.$translate.instant(
                'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.CONFIRM_INSTANT_DEPOSIT._DESCRIPTION_',
                {last4: this.user.myDebitCard().last4}),
                confirmButtonLabel: 'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.CONFIRM_INSTANT_DEPOSIT._MAIN_CTA_',
                fee: this.$translate.instant(
                'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.CONFIRM_INSTANT_DEPOSIT._FEE_',
                {fee_amount: this.payment.instant_payout_theoretical_fee}),
                note: 'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.CONFIRM_INSTANT_DEPOSIT._NOTE_',
                mainCta: this.confirmDepositNow.bind(this)
            };
            this.STEPS.CONFIRM_INSTANT_DEPOSIT_INITIATED = {
                event: this.AnalyticsService.analytics_events.confirm_instant_deposit_initiated,
                icon: 'icon-hb-nx-check-42',
                title: 'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.CONFIRM_INSTANT_DEPOSIT_INITIATED._TITLE_',
                description: this.$translate.instant(
                'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.CONFIRM_INSTANT_DEPOSIT_INITIATED._DESCRIPTION_',
                {total_amount: this.getAmount()}),
                confirmButtonLabel: 'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.CONFIRM_INSTANT_DEPOSIT_INITIATED._MAIN_CTA_',
                note: 'COMPANY_SETTING.BANK_ACCOUNT.INSTANT_DEPOSIT_MODAL.CONFIRM_INSTANT_DEPOSIT_INITIATED._NOTE_',
                mainCta: this.confirmInstantDepositInitiated.bind(this)
            };
        },

        confirmInstantDepositInitiated: function confirmInstantDepositInitiated() {
            this.$modalInstance.close();
        },

        confirmDepositNow: function confirmDepositNow() {
            this.loading = true;
            this.WorkspaceFilesManager.markPaymentAsInstantPayout(this.workspaceFileId, this.payment._id, true).then(
                function onSuccess(resp) {
                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.toggle_instant_payment,
                        {newState: true, source: 'instant deposit modal'});
                    this.currentStep = this.STEPS.CONFIRM_INSTANT_DEPOSIT_INITIATED;
                    this.loading = false;
                    this.loadingModalContent = false;
                }.bind(this)).catch(
                function onError(resp) {
                    this.loading = false;
                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.toggle_instant_payment, resp);
                    if(resp.data && resp.data.error_message) {
                        this.handleError(this.ERROR_TYPES.NOT_ALLOWED);
                    } else {
                        this.handleError();
                    }
                }.bind(this));
        },

        isWithinTimeFrame: function isWithinTimeFrame(chargeDate) {
            var maxDateForInstant = this.moment(chargeDate).add(1, 'days');
            return this.moment().isBefore(maxDateForInstant);
        },

        getAmount: function getTotal() {
            return this.payment.hb_vendor_transfer_amount - this.payment.instant_payout_theoretical_fee;
        },

        cancel: function cancel() {
            this.$modalInstance.dismiss();
        }
    });
}());
